export interface BlobUploadResponse {
  fileUrl?: string;
  fileName?: string;  
  fileSize?: number;
  fileType?: string;
  fileDuration?: string;
  stage?: 'select' | 'upload' | 'soft-delete' | 'exist-delete';
  status?: boolean;
  file?: any;
}

export interface BlobUploadRegistry {
  baseUrl?: string;
  container?: string;
  file: File;
}